













import Vue from 'vue'
import HistoryItem from './HistoryItem.vue'
import Loader from '@/components/Common/Loader.vue'
import { HistoryItem as IHistoryItem } from '@/models/scripts'

interface Computed {
  history: IHistoryItem[]
}

interface Props {
  isReady: boolean
}

export default Vue.extend<{}, {}, Computed, Props>({
  components: {
    HistoryItem,
    Loader,
  },
  props: {
    isReady: {
      default: false,
    },
  },
  computed: {
    history(): IHistoryItem[] {
      return this.$store.getters.getRecordingsHistory
    },
  },
  updated() {
    const element: Element = this.$refs.scrollView as Element
    if (element) {
      element.scrollIntoView({ block: 'end', behavior: 'smooth' })
    }
  },
})
